
import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class ContenidoApi {
    
    static activar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},         	url: getLocacion()+ "/api/contenido/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},         	url: getLocacion()+ "/api/contenido/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getContenidoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
        let combos="";
         if(filtrosCombo){
             for (var comboValue in filtrosCombo) {
                  //if(filtrosCombo[comboValue]!="" && !isNaN(filtrosCombo[comboValue])){                      
                      combos+="&"+comboValue+"="+filtrosCombo[comboValue];
                  //}
            }
             
        }
        
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 			
            url: getLocacion()+ "/api/contenido?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos+combos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getContenidosList(idModulo, token ) {
        
        return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
            url: getLocacion()+ "/api/contenido/contenidos/"+idModulo,
            statusCode: {
                401: function() {
                   // Only if your server returns a 403 status code can it come in this block. :-)					
                    window.location = getLocacion()+'/login';
                }
            }
		});
      
	}
    
    
    static getContenidoDetalle(id, token) {  
     return $.ajax({
        headers: {"Authorization": "Bearer " + token.idToken}, 			
         url: getLocacion()+ "/api/contenido/detalle/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static getContenido(id, token ) {  
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 			url: getLocacion()+ "/api/contenido/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static getContenidoConf(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 	
            url: getLocacion()+ "/api/contenido/moduloc/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(contenido, token ) {          
      let contenidoEnvio = Object.assign({}, contenido);
		let comando="POST";
		if (contenidoEnvio.id > 0) {
			comando="PUT";			
		} 
		contenidoEnvio=JSON.stringify(contenidoEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 			url: getLocacion()+ "/api/contenido/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: contenidoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    
    static saveConfig(contenido, token ) {          
      let contenidoEnvio = Object.assign({}, contenido);
		let comando="POST";
		if (contenidoEnvio.id > 0) {
			comando="PUT";			
		} 
		contenidoEnvio=JSON.stringify(contenidoEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 			
            url: getLocacion()+ "/api/contenido/config/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: contenidoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static saveTime(contenido, token ) {          
      let contenidoEnvio = Object.assign({}, contenido);
        let comando="PUT";			
		contenidoEnvio=JSON.stringify(contenidoEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},
            url: getLocacion()+ "/api/contenido/tiempo/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: contenidoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	} 
    
    static getContenidoCombo(token ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 			
            url: getLocacion()+ "/api/contenido/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
       static getContenidoComboAndTipo(token ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 			
            url: getLocacion()+ "/api/contenido/comboTipo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     
    static getArchivosDisponibles(tipo, token, prefijo ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 			
            url: getLocacion()+ "/api/contenido/archivos/"+tipo+"/"+prefijo,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static saveFile(file, token) {  
		return $.ajax({
			url: getLocacion()+"/api/contenido/upload/",
             headers: {"Authorization": "Bearer " + token.idToken},  
            contentType: false,
            processData: false,            
            type: 'POST',
			data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location ='/login';
				}
			}
		});
	}
    
}